import React from "react";
import * as notify from "../../../shared/notify";

import { Input } from "../../form-inputs/inputs";
import { addSupplier } from "../lib/shipmentData";
import { useInput } from "../../../shared/hooks/form-fields";

const NewSupplier = (props) => {
    const inputCode = useInput("");
    const inputName = useInput("");

    const onAdd = (e) => {
        e.preventDefault();
        const code = inputCode.value;
        const name = inputName.value;

        addSupplier({ code, name })
            .catch((err) => {
                notify.error("Unable to save supplier");

                return false;
            })
            .then((result) => {
                if (!result) {
                    return;
                }

                if (props.updateSuppliers) {
                    props.updateSuppliers(code);
                    notify.success(`Supplier ${name} has been added`);
                    inputCode.reset();
                    inputName.reset();
                }
            });
    };

    return (
        <div>
            <Input label="Supplier Code" name="code" {...inputCode.bind} />
            <Input label="Supplier Name" name="name" {...inputName.bind} />
            <button className="button -primary" onClick={onAdd}>
                Add
            </button>
        </div>
    );
};

export default NewSupplier;
